import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { IJobOffer } from '../../../../../assets/types/dtoTypes';
import { HttpClient } from '@angular/common/http';

@Injectable( {
  providedIn: 'root',
} )
export class MainPageService {
  private http = inject(HttpClient);

  private jobOffersUrl = `${environment.apiUrl}/job-offers`;


  constructor() {}

  // Get all job offers
  getJobOffers(): Observable<IJobOffer[]> {
    return this.http.get<IJobOffer[]>( `${environment.apiUrl}/job-offers` );
  }

  createJobOffer( jobOffer: IJobOffer ): Observable<IJobOffer> {
    return this.http.post<IJobOffer>( this.jobOffersUrl, jobOffer );
  }

  // Get a job offer by ID
  getJobOfferById( id: string ): Observable<IJobOffer> {
    return this.http.get<IJobOffer>( `${this.jobOffersUrl}/${id}` );
  }
}
